import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '../../routers/AppRouter';
import { setToggleAuthSetting } from '../../actions/css'
import { logout } from '../../actions/auth';
import { deleteToken } from '../../helpers/auth';
import paths from '../../helpers/paths';
import AccountSettings from '../../images/icons/accountsettings.png';
import Support from '../../images/icons/support.png';
import LogOut from '../../images/icons/logout1.png';

const AuthSettings = () => {
  const dispatch = useDispatch();
  const { toggleAuthSettings } = useSelector(state => state.css);
  const { userDetails } = useSelector(state => state.auth);
  return (
    <Fragment>
      {toggleAuthSettings && <div className='profile-account-settings'>
      <table className='profile-account-details-settings'>
        <tbody>
          <tr>
            {!(userDetails && userDetails.isLoggedIn) ? <td className='profile-account-details-settings-icon'><img src={AccountSettings}/></td> : ``}
            {!(userDetails && userDetails.isLoggedIn) ? <td className='profile-account-details-settings-naming'>
              <a onClick={() => {
                dispatch(setToggleAuthSetting(!toggleAuthSettings));
                history.push(paths.login);
              }} className='authset' href='#'>Account Log In</a>
            </td> : ``}
          </tr>
          <tr>
            <td className='profile-account-details-settings-icon'><img src={Support}/></td>
            <td className='profile-account-details-settings-naming'>
              <a onClick={() => {
                 dispatch(setToggleAuthSetting(!toggleAuthSettings));
                history.push(paths.signup);
              }} className='authset' href='#'>Account Sign Up</a>
            </td>
          </tr>
          <tr onClick={() => {
            deleteToken();
            dispatch(logout());
            history.push(paths.login);
          }}>
            {!(userDetails && userDetails.isLoggedIn) ? '' : <td className='profile-account-details-settings-icon'><img src={LogOut} alt='' title=''/></td>}
            {!(userDetails && userDetails.isLoggedIn) ? '' : <td className='profile-account-details-settings-naming'>
              <a className='authset' href='#'>Log Out</a>
            </td>}
          </tr>
        </tbody>
      </table>
    </div>}
    </Fragment>
  );
};

export default AuthSettings;
